module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/05049991b8bdd02953cb06416819b07b.png";